/* eslint-disable */
const localization = {
    // This is the array of lexemes found in the app
    lexemes: [
      "The Friendship Hub",
      "Find New Friends With Bumble For Friends App | Bumble",
      "Download on the App Store",
      "Get it on Google Play",
      "A dedicated space to make new friends",
      "Discover people near you who are here for genuine connections.",
      "Find friends for all stages of life",
      "New to town? Need a fresh start? Your new crew is waiting for you!",
      "A safe space for everyone",
      "Welcome to a kind part of the internet, where you can be you.",
      "Download the app",
      "Meet IRL with people who share your interests!",
      "Get to know a new group of people with Plans on Bumble For Friends",
      "You’ve been invited to join Plans",
      "Plans is a new feature on Bumble For Friends where you can create and join group meetups with new friends near you",
      "Manage Cookies",
      "Gender Pay Gap",
      "Modern Slavery Statement",
      "Terms and Conditions",
      "About",
      "Life"
],

    // These are the common words found in the lexemes of the app
    common: {
      "day": {
            "few": [
                  "дні",
                  "днів",
                  "дням",
                  "дні",
                  "днями",
                  "днях"
            ],
            "many": [
                  "днів",
                  "днів",
                  "дням",
                  "днів",
                  "днями",
                  "днях"
            ],
            "plural": [
                  "дня",
                  "дня",
                  "дня",
                  "дня",
                  "дня",
                  "дня"
            ],
            "singular": [
                  "день",
                  "дня",
                  "дню",
                  "день",
                  "днем",
                  "дні"
            ]
      },
      "hour": {
            "few": [
                  "години",
                  "годин",
                  "годинам",
                  "години",
                  "годинами",
                  "годинах"
            ],
            "many": [
                  "годин",
                  "годин",
                  "годинам",
                  "годин",
                  "годинами",
                  "годинах"
            ],
            "plural": [
                  "години",
                  "години",
                  "години",
                  "години",
                  "години",
                  "години"
            ],
            "singular": [
                  "година",
                  "години",
                  "годині",
                  "годину",
                  "годиною",
                  "годині"
            ]
      },
      "minute": {
            "few": [
                  "хвилини",
                  "хвилин",
                  "хвилинам",
                  "хвилини",
                  "хвилинами",
                  "хвилинах"
            ],
            "many": [
                  "хвилин",
                  "хвилин",
                  "хвилинам",
                  "хвилин",
                  "хвилинами",
                  "хвилинах"
            ],
            "plural": [
                  "хвилини",
                  "хвилини",
                  "хвилини",
                  "хвилини",
                  "хвилини",
                  "хвилини"
            ],
            "singular": [
                  "хвилина",
                  "хвилини",
                  "хвилині",
                  "хвилину",
                  "хвилиною",
                  "хвилині"
            ]
      },
      "month": {
            "few": [
                  "місяці",
                  "місяців",
                  "місяцям",
                  "місяці",
                  "місяцями",
                  "місяцях"
            ],
            "many": [
                  "місяців",
                  "місяців",
                  "місяцям",
                  "місяців",
                  "місяцями",
                  "місяцях"
            ],
            "plural": [
                  "місяця",
                  "місяця",
                  "місяця",
                  "місяця",
                  "місяця",
                  "місяця"
            ],
            "singular": [
                  "місяць",
                  "місяця",
                  "місяцю",
                  "місяць",
                  "місяцем",
                  "місяці"
            ]
      },
      "second": {
            "few": [
                  "секунди",
                  "секунд",
                  "секундам",
                  "секунди",
                  "секундами",
                  "секундах"
            ],
            "many": [
                  "секунд",
                  "секунд",
                  "секундам",
                  "секунд",
                  "секундами",
                  "секундах"
            ],
            "plural": [
                  "секунди",
                  "секунди",
                  "секунди",
                  "секунди",
                  "секунди",
                  "секунди"
            ],
            "singular": [
                  "секунда",
                  "секунди",
                  "секунді",
                  "секунду",
                  "секундою",
                  "секунді"
            ]
      },
      "year": {
            "few": [
                  "роки",
                  "років",
                  "рокам",
                  "роки",
                  "роками",
                  "роках"
            ],
            "many": [
                  "років",
                  "років",
                  "рокам",
                  "років",
                  "роками",
                  "роках"
            ],
            "plural": [
                  "року",
                  "року",
                  "року",
                  "року",
                  "року",
                  "року"
            ],
            "singular": [
                  "рік",
                  "року",
                  "року",
                  "рік",
                  "роком",
                  "році"
            ]
      }
}
};

// In dev mode we extend lexemes to include the indexMap as well, in production it remains as an array
if (__DEV__) {
    // This is a map of lexeme ids to their index in the array, it's only needed during development
    const indexMap = require('./index-map').default;

    localization.indexMap = indexMap;

    Object.entries(localization.indexMap).forEach(([indexKey, indexValue]) => {
        localization.lexemes[indexKey] = localization.lexemes[indexValue];
    });
}

export default localization;
